module.exports = __webpack_public_path__ + "img/car.8842ce28.png";